module.exports = __webpack_public_path__ + "static/media/hospital-week-3.d2c8819b.jpg";